// extracted by mini-css-extract-plugin
module.exports = {"pin":"Marker_pin__3XPC2","modal":"Marker_modal__VH3nd"};